import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { BaseRequestPolicy } from '@azure/ms-rest-js';
export class CustomHeaderPolicy extends BaseRequestPolicy {
  // eslint-disable-next-line max-params -- @azure/ms-rest-js requires more parameters
  constructor(nextPolicy, options, headerKey, headerValue) {
    super(nextPolicy, options);
    _defineProperty(this, "headerKey", void 0);
    _defineProperty(this, "headerValue", void 0);
    this.headerKey = headerKey;
    this.headerValue = headerValue;
  }
  async sendRequest(request) {
    this.addCustomHeader(request);
    return this._nextPolicy.sendRequest(request);
  }
  addCustomHeader(request) {
    if (!request.headers.get(this.headerKey) && this.headerValue) {
      request.headers.set(this.headerKey, this.headerValue);
    }
  }
}
//# sourceMappingURL=CustomHeaderPolicy.js.map